import {
  Box,
  Divider,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { appIcons } from "../../assets";

const style = {
  muiTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
    },
  },
};

function CustomContainer({
  headProps,
  children,
  primaryHeading,
  secondaryHeading,
  showBackButton,
  handleBack,
  childrenProps,
  customIcom,
  paperProps,
  paperSxProps,
  menuBarProps,
}) {
  return (
    <Paper {...paperProps} sx={{ borderRadius: "6px", ...paperSxProps }}>
      <Stack
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { sm: "center" },
          gap: { xs: 1.5, sm: 0 },
        }}
      >
        <Stack gap={2} direction={"row"} alignItems={"center"} flexGrow={1}>
          {showBackButton ? (
            <IconButton
              onClick={handleBack}
              disableRipple
              sx={{
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <img
                src={appIcons.purpleBackArrowIcon}
                alt={"back-arrow-icon"}
                width={30}
                height={30}
              />
            </IconButton>
          ) : customIcom ? (
            customIcom
          ) : (
            <img
              src={appIcons.blackDashboardIcon}
              alt={"back-icon"}
              width={30}
              height={30}
            />
          )}
          <Box>
            <Typography
              fontSize={"1.125rem"}
              fontWeight={600}
              lineHeight={"normal"}
              textTransform={"capitalize"}
            >
              {primaryHeading}
            </Typography>
            <Typography
              variant={"body2"}
              fontSize={"0.8rem"}
              color={"text.coolGrey"}
            >
              {secondaryHeading}
            </Typography>
          </Box>
        </Stack>
        {headProps && headProps}
      </Stack>
      <Divider />
      {menuBarProps && menuBarProps}

      <Box p={{ xs: "8px", md: "24px 30px" }} {...childrenProps}>
        {children}
      </Box>
    </Paper>
  );
}

export default CustomContainer;
